/* eslint-disable camelcase */
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import moduleMargins from 'config/theme/moduleMargins';
import styled from 'libs/styled';
import Heading from 'components/text/Heading';
import TextBlock from 'libs/wordpress/content/cmsBlocks/TextBlock';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import { above } from 'utils/mediaqueries';

const HeadingWrapper = styled('div')`
display: flex;
flex-direction: column;
    text-wrap: pretty;
    width: 100%;

    ${above.sm}{
        width: 83.33%;
    }
`;

const InformationTextSectionModule = ({ content }) => {
    const {
        data: TextBlockData,
        heading,
        content: { content_alignment: contentAlignment },
    } = content;

    const contentLeft = contentAlignment === 'left';

    return (
        <MaxWidthWrapper includeContentMargins as="section" my={moduleMargins.xxs}>
            <ColumnsLayout
                blocks={[
                    <HeadingWrapper order={contentLeft ? [1, null, 2] : 1} alignItems={contentLeft ? 'flex-end' : 'flex-start'} >
                        <Wysiwyg
                            data={heading}
                            textComponent={props => (
                                <Heading as="h3"size="lg" {...props} />
                            )}
                        />
                    </HeadingWrapper>,
                    <TextBlock content={TextBlockData} isColumn order={contentLeft ? [2, null, 1] : 2} />
                ]}
                columnSizes={[12, null, 6]}
            />
        </MaxWidthWrapper>
    );
};

InformationTextSectionModule.propTypes = {
    content: PropTypes.shape({
        content: PropTypes.shape({
            content_alignment: PropTypes.oneOf(['left', 'right']),
        }),
        background_media_flexible: PropTypes.exact({
            mobile: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
            desktop: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
        }),
    }).isRequired,
};

export default InformationTextSectionModule;
